"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m18.658 13.909-.515.474-.514-.474a.7.7 0 0 1 1.03 0m-.515 1.555c-.155.195-.33.424-.506.672a8 8 0 0 0-.682 1.13c-.186.386-.268.688-.268.891 0 .8.657 1.457 1.456 1.457.8 0 1.457-.657 1.457-1.458 0-.202-.082-.505-.268-.89a8 8 0 0 0-.682-1.13c-.175-.248-.35-.477-.507-.672m2.451 1.195c.219.456.406.983.406 1.497a2.864 2.864 0 0 1-2.857 2.858 2.863 2.863 0 0 1-2.856-2.857c0-.514.187-1.042.406-1.498.225-.468.518-.93.8-1.33A16 16 0 0 1 17.6 13.94l.02-.022.006-.006.003-.004.514.475.515-.474.003.002.006.007.02.022.074.083a15.775 15.775 0 0 1 1.033 1.306c.282.4.575.861.8 1.33M7.844 3.198a.7.7 0 0 1 .99-.013l1.299 1.262 5.042 5.043a3.756 3.756 0 0 1 0 5.312l-2.882 2.881a3.756 3.756 0 0 1-5.311 0L4.1 14.802a3.756 3.756 0 0 1 0-5.312l4.54-4.54-.782-.762a.7.7 0 0 1-.014-.99m1.794 2.734 4.547 4.548c.334.334.547.743.638 1.173l-10.37-.008a2.35 2.35 0 0 1 .637-1.165zm-5.06 7.113c.115.279.286.54.512.767l2.881 2.881c.92.92 2.412.92 3.333 0l2.88-2.881a2.35 2.35 0 0 0 .51-.759z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BackgroundColorIcon24.js.map